module.exports = __webpack_public_path__ + "static/img/gxhdz64.4e356ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gxhdz64.png
// module id = B2iG
// module chunks = 73